import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function ArticlePreviewSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = articlePreviews[currentIndex];

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? articlePreviews.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === articlePreviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-10">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-accent-200 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Articles SEO
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
            Guides &amp; ressources<br />Hipobuy Spreadsheet
          </h2>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          {/* Image */}
          <Link
            to="/guide-hipobuy-spreadsheet"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="lg:w-2/5 shrink-0 rounded-2xl overflow-hidden cursor-pointer group"
          >
            <div className="aspect-[4/3] md:aspect-[3/4] lg:aspect-[4/3] overflow-hidden bg-accent-100">
              <img
                src={current.imageUrl}
                alt={current.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          </Link>

          {/* Text */}
          <div className="lg:w-3/5 flex flex-col justify-center">
            <span className="text-primary-600 text-xs font-semibold tracking-wider uppercase mb-3">
              (Guide SEO)
            </span>
            <Link
              to="/guide-hipobuy-spreadsheet"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer group"
            >
              <h3 className="text-2xl md:text-4xl font-heading text-foreground-950 leading-tight mb-2">
                {current.title}
              </h3>
              <p className="text-2xl md:text-4xl font-heading text-foreground-300 leading-tight mb-6">
                {current.subtitle}
              </p>
            </Link>
            <blockquote className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6 border-l-2 border-primary-300 pl-5 italic">
              &ldquo;{current.excerpt}&rdquo;
            </blockquote>
            <p className="text-foreground-800 text-sm font-semibold">
              &mdash; {current.author}
            </p>

            {/* Nav arrows */}
            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={goPrev}
                className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:bg-foreground-100 hover:text-foreground-800 transition-colors cursor-pointer"
                aria-label="Article précédent"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="Article suivant"
              >
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </button>
              <span className="text-foreground-400 text-sm ml-2">
                {currentIndex + 1} / {articlePreviews.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}